// Dev Debugging config TEMP
export const debug = {
  useDebugMode: process.env.REACT_APP_DEBUG_MODE,

  enhancedLog: (use, title, color, data = null) => {
    if (use && data) {
      return console.log(`%c======<<<<<<<<<<// ${title} //>>>>>>>>>>>=====`, `background: #c1c1c1; color: ${color}`, data);
    }

    if (use) {
      return console.log(`%c======<<<<<<<<<<// ${title} //>>>>>>>>>>>=====`, `background: #c1c1c1; color: ${color}`);
    }
  },
};
